import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://ims.holdthechild.net/api",
});

// Automatically attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Adjust if you store token elsewhere
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
